import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { apiLogin, apiMe } from "@/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined=checking, null=logged out
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("nv_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    apiMe()
      .then(setUser)
      .catch(() => {
        localStorage.removeItem("nv_token");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { token, user } = await apiLogin(email, password);
    localStorage.setItem("nv_token", token);
    setUser(user);
    return user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("nv_token");
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
